import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogList from "./sections/BlogList";
import DownloadCta from "./sections/DownloadCta";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogList />
      <DownloadCta />
      <Footer />
    </div>;
}